// A part's two lookup pages (2026-10-19), one place for every link to them:
// the Items widget rows, the header's item fields and the listing banner.
// Item Info encodes the SKU as a query value; the 1A site path takes it as
// written, as it always has.
export function itemInfoUrl(sku) {
  return `https://ii.1aauto.inc/customerservice?sku=${encodeURIComponent(sku)}`
}

export function oneASiteUrl(sku) {
  return `https://www.1aauto.com/*/i/${sku}`
}
